
<template>
  <div class="tip-overlay"  @click="$emit('close')">
    <div class="tip-content">
      <!-- Top Arrow -->
      <img src="../assets/images/arror_1.png" alt="arrow" class="arrow-top" />
      <div style="height: 30px;"></div>
      <!-- More Icon Tip -->
     <div class="top-tip-item">
        <div class="tip-item more-tip">
            <div class="tip-text">{{ multiLan('tap_more') }}</div>
            <div style="width:30px;"></div>
            <img src="../assets/images/more_icon.png" alt="more" class="more-icon" />
    
        </div>
        <div style="width:50px;"></div>
     </div>

      <!-- Middle Arrow -->
     <div class="middle-arrow-wrapper">
        <img src="../assets/images/arror_3.webp" alt="arrow" class="arrow-middle" />
        <div style="width:50px;"></div>
     </div>
     <div class="middle-tip-item">
       
      <!-- Chrome Icon Tip -->
      <div class="tip-item chrome-tip">
        <div class="tip-text">{{ multiLan('open_external_browser') }}</div>
        <div style="width: 30px;"></div>
        <!-- <img src="../assets/images/chrome_icon.png" alt="chrome" class="chrome-icon" /> -->
      </div>
      <div style="width:50px;"></div>
     </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { multiLan } from '../assets/lan';
onMounted(() => {
    console.log('openInDefaultTip mounted')
})
defineEmits(['close'])

</script>

<style lang="scss" scoped>
.tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 20px;
}

.tip-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 20px;
  margin-top: 10px;
}

.tip-item {
  display: flex;
  align-items: center;
  color: white;
  padding: 10px 15px;
  border-radius: 8px;
  margin: 10px 0;
  
  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  .more-icon{
    width: 66px;
    height: 66px;
  }
  .chrome-icon{
    width: 66px;
    height: 66px;
  }
  .tip-text {
    color: white;
    font-size: 16px;
    white-space: nowrap;
  }
}

.arrow-top {
  width: 86px;

  height: 58px;
  object-fit: cover;
  position: absolute;
  top: -15px;
  right: 10px;
  transform: rotate(180deg);
}

.arrow-middle {
  width: 71px;
  height: 88px;
  margin: 5px 20px;
}
.top-tip-item{
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
}
.middle-tip-item{
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
}
.middle-arrow-wrapper{
    display: flex;
    justify-content: flex-end;
    flex-direction: row; 
}
.more-tip {
  margin-top: 20px;
}

.chrome-tip {
  margin-bottom: 20px;
}
</style>